import { Task } from './task';
import { LocalDate } from '../../common/domain/date/local-date';

export enum ConfirmCloseTaskActionsShow {
  ALWAYS = 'always',
  NEVER = 'never',
  OUTSIDE_VALID_DATE_RANGE = 'outside-valid-date-range',
}

export type ConfirmCloseTaskActionsData = {
  show: ConfirmCloseTaskActionsShow;
  fields: {
    resolutions: {
      show: boolean;
      show_in_bulk: boolean;
      options: Array<{
        id: string;
        name: string;
        isFinal: boolean;
      }>;
    };
  };
};

export class ConfirmCloseTaskActions {
  constructor(public readonly value: ConfirmCloseTaskActionsData) {}

  shouldShowModalForTask(task: Task) {
    if (this.value.show === ConfirmCloseTaskActionsShow.ALWAYS) {
      return true;
    }

    if (this.value.show === ConfirmCloseTaskActionsShow.OUTSIDE_VALID_DATE_RANGE) {
      const today = LocalDate.now();
      return !task.date.range.isInRange(today);
    }

    if (this.value.show === ConfirmCloseTaskActionsShow.NEVER) {
      return false;
    }

    // otherwise
    return false;
  }

  shouldShowResolutions(bulkMode: boolean = false): boolean {
    if (!this.value.fields.resolutions) {
      return false;
    }

    if (bulkMode) {
      return this.value.fields.resolutions.show_in_bulk;
    }

    return this.value.fields.resolutions.show;
  }

  optionsForResolutions(): Array<{ id: string; label: string }> {
    const allOptions = this.value.fields.resolutions.options;

    return allOptions.map((o) => ({
      id: o.id,
      label: o.name,
    }));
  }

  isResolutionFinal(resolutionId: string): boolean {
    return this.value.fields.resolutions.options.find((r) => r.id === resolutionId)?.isFinal ?? false;
  }
}
